import { openModal } from './navigationController';
import type { Root } from './prototypeTypes';

/**
 * Consumes the one supported cross-site authentication intent after the
 * authoritative session response has resolved. Keeping this separate from
 * general deep links prevents an unverified URL parameter from opening a
 * credential surface before the current visitor/member state is known.
 */
export function consumeLoginAuthIntent(root: Root, authStatus: unknown): boolean {
	if (typeof window === 'undefined') return false;
	if (authStatus !== 'visitor' && authStatus !== 'authenticated') return false;

	const url = new URL(window.location.href);
	const values = url.searchParams.getAll('auth');
	if (values.length !== 1 || values[0] !== 'login') return false;

	url.searchParams.delete('auth');
	window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
	if (authStatus === 'visitor') openModal(root, 'loginModal');
	return true;
}
